import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import stJeansLogo from './assets/st-jeans-logo-600px.webp'
import { Image as ReactImage } from 'react-bootstrap';
import api from './api.js'
import auth from './db/auth.js'
import Footer from './Footer.jsx'
import syncDb from './serviceWorker/syncDb'

function LogIn() {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [loggingIn, setLoggingIn] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (auth.getJwt()) {
      navigate("/", { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function showToast(message) {
    const toast = document.getElementById('toast')
    toast.getElementsByClassName("message")[0].innerHTML = message

    if (toast.style.display && toast.style.display !== "none") {
      return // already visible
    }

    toast.style.display = "flex"
    setTimeout(() => {
      toast.classList.add("fade")
      setTimeout(() => {
        toast.style.display = "none"
        toast.classList.remove("fade")
      }, 500)
    }, 5000)
  }

  function hideToast() {
    const toast = document.getElementById('toast')
    toast.classList.remove("fade")
    toast.style.display = "none"
  }

  async function handleSubmit() {
    if (!username || !password) {
      showToast("Need a username and password")
      return
    }

    // Valid
    try {
      setLoggingIn(true)
      await api.logIn({ username: username, password: password })
      await syncDb(true) // Use log in as a way to trigger a full reset of local DB
      navigate("/", { replace: true })
    } catch (e) {
      console.error(e)
      showToast(e.message)
      window.scrollTo({ top: 0, left: 0, behavior: "instant" })
      return
    } finally {
      setLoggingIn(false)
    }

    // setSavedOrder(response.data)
  }

  function onPasswordKeyDown(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      handleSubmit()
    }
  }

  return (
    <>
      <Row className="d-flex justify-content-center">
        <Col className="col-auto position-fixed top-0 start-50 translate-middle-x p-3" style={{ zIndex: 11 }}>
          <Row id="toast" className="toast hide bg-danger border-danger p-3" role="alert" aria-live="assertive" aria-atomic="true">
            <Col className="message text-light fs-5 d-flex flex-column justify-content-center">
            </Col>
            <Col xs={1} className="d-flex flex-column justify-content-center">
              <button type="button" onClick={hideToast} className="btn btn-danger fs-5" data-bs-dismiss="toast" aria-label="Close"><i className="bi bi-x-lg"></i></button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <div id="order-form-page" className="d-flex flex-column align-items-center">
          <span className="display-3 mt-5">Log In</span>
          <Row className="order-form-body mt-5 py-4 px-5 d-flex justify-content-center">
            <Col>
              <Row className="mt-5 d-flex justify-content-between">
                <Col xs={4} className="d-flex flex-column align-items-center">
                  <ReactImage src={stJeansLogo} fluid />
                </Col>
                <Col xs={7} className="d-flex flex-column justify-content-center">
                  <Row className="d-flex align-items-center">
                    <Col xs={4}>
                      <span className="fs-4 fw-bold">Username:</span>
                    </Col>
                    <Col>
                      <Form.Control placeholder="username" className="fs-4" value={username} onInput={e => setUsername(e.currentTarget.value)} autoFocus />
                    </Col>
                  </Row>
                  <Row className="d-flex align-items-center mt-3">
                    <Col xs={4}>
                      <span className="fs-4 fw-bold">Password:</span>
                    </Col>
                    <Col>
                      <Form.Control placeholder="***********" type="password" className="fs-4" value={password} onInput={e => setPassword(e.currentTarget.value)} onKeyDown={onPasswordKeyDown} />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="my-5 d-flex justify-content-center">
                <Col className="col-auto">
                  <Button className="btn-primary fs-5 py-2 px-5" onClick={handleSubmit} disabled={loggingIn}>
                    {loggingIn ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        <span>Logging In...</span>
                      </>
                    ) : (
                      <span>Log In</span>
                    )}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Row>
      <Footer />
    </>
  );
}

export default LogIn;